import { Component, inject } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'
import { PrimeTemplate } from 'primeng/api'
import { Button } from 'primeng/button'
import { Checkbox } from 'primeng/checkbox'
import { Fluid } from 'primeng/fluid'
import { InputText } from 'primeng/inputtext'
import { Panel } from 'primeng/panel'

import { LanguageService } from '@ti/core/ui-kit/i18n'
import { LangToggleComponent } from '@ti/core/ui-kit/layout/components/lang-toggle'
import { PasswordInputComponent } from '@ti/core/ui-kit/layout/components/password-input'
import { BaseSignInComponent, ForgotPasswordComponent } from '@ti/shared/auth-ui/components'
import { AuthenticatorCodeDialogComponent } from '@ti/shared/auth-ui/components/authenticator-code-dialog'
import { AuthenticatorSetupDialogComponent } from '@ti/shared/auth-ui/components/authenticator-setup-dialog'

import { McpAuthContext } from '../../../../mcp/bootstrap/mcp-auth-context'
import { isMcpLandingReturnUrl } from '../../../../mcp/bootstrap/mcp-interaction-capture'

@Component({
  selector: 'app-sign-in-page',
  templateUrl: 'sign-in-page.component.html',
  styleUrl: 'sign-in-page.component.scss',
  imports: [
    Fluid,
    PrimeTemplate,
    Panel,
    ReactiveFormsModule,
    InputText,
    PasswordInputComponent,
    TranslatePipe,
    ForgotPasswordComponent,
    Button,
    Checkbox,
    LangToggleComponent,
    AuthenticatorCodeDialogComponent,
    AuthenticatorSetupDialogComponent,
  ],
})
export class TiAdminSignInPageComponent extends BaseSignInComponent {
  protected override languageService = inject(LanguageService)
  private readonly mcpContext = inject(McpAuthContext)

  protected override checkIsUserActive() {
    return this.mcpContext.isAuthFlow && isMcpLandingReturnUrl(this.returnUrl)
      ? Promise.resolve(true)
      : super.checkIsUserActive()
  }

  protected override trackLogin() {
    if (!this.mcpContext.isAuthFlow || !isMcpLandingReturnUrl(this.returnUrl)) super.trackLogin()
  }
}
